import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function AgeGate() {
  const [allowed, setAllowed] = useState(() =>
    localStorage.getItem("nl_age_ok") === "true"
  );

  useEffect(() => {
    document.body.style.overflow = allowed ? "auto" : "hidden";
  }, [allowed]);

  const enter = () => {
    localStorage.setItem("nl_age_ok", "true");
    setAllowed(true);
  };

  const leave = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {!allowed && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center marble-hero px-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="age-gate-overlay"
        >
          <div className="absolute inset-0 bg-white/60 backdrop-blur-md" />
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
            className="relative z-10 w-full max-w-md border border-black/10 bg-white p-10 text-center shadow-[0_20px_60px_rgba(43,37,32,0.12)]"
          >
            <p className="overline mb-4">The Good Life</p>
            <h1 className="mb-4 text-4xl font-black leading-none text-[#2b2520]">
              Are you <span className="gold-text">21</span> or older?
            </h1>
            <p className="mb-8 text-sm text-neutral-600">
              You must be of legal age to enter. By entering, you confirm that
              you are 21 years of age or older.
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={enter}
                data-testid="age-gate-yes"
                className="w-full bg-[#c99a63] py-3 text-sm font-semibold uppercase tracking-widest text-[#2b2520] transition-colors duration-300 hover:bg-[#bb8850]"
              >
                Yes, enter
              </button>
              <button
                onClick={leave}
                data-testid="age-gate-no"
                className="w-full border border-black/15 py-3 text-sm font-semibold uppercase tracking-widest text-[#2b2520] transition-colors duration-300 hover:border-black/30"
              >
                No, take me back
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
